/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Page_Tutorials_DescriptionInputs */

const en_cad_page_tutorials_description = /** @type {(inputs: Cad_Page_Tutorials_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn CADCraft step by step: command line, coordinates, drawing and editing, object snaps, layers, dimensions, layouts, export, and automation with the CLI and MCP.`)
};

/**
* | output |
* | --- |
* | "Learn CADCraft step by step: command line, coordinates, drawing and editing, object snaps, layers, dimensions, layouts, export, and automation with the CLI a..." |
*
* @param {Cad_Page_Tutorials_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_page_tutorials_description = /** @type {((inputs?: Cad_Page_Tutorials_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Page_Tutorials_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_page_tutorials_description(inputs)
});
export { cad_page_tutorials_description as "cad.page.tutorials.description" }